import {unwrapResult} from '@reduxjs/toolkit';
import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {requestOK} from 'redux-thunk-kit';
import clock from '~/assets/images/clock.svg';
import welcome1 from '~/assets/images/welcome-1.png';
import {Col, Row, UiDivider, UiImage, UiPageLoading, UiQuestionnaireLayout, UiText} from '~/components/elements';
import {PAGE_URLS} from '~/constants';
import {
  METHOD_KEYS,
  WEIGHT_LOSS_RENEWAL_KEYS,
  WEIGHT_LOSS_RENEWAL_QUESTIONNAIRES,
} from '~/constants/medical-questionnaires';
import {useRequestState} from '~/hooks';
import {setMedicalUUID, setMethodKey, setQuestionnaireAnswer, setQuestionnaireMeta} from '~/redux/questionnaires/slice';
import {getMdqStatus, submitOrLogMdq} from '~/redux/questionnaires/thunk';
import {RootState} from '~/redux/root-reducer';
import {AppDispatch} from '~/redux/root-store';
import {MDQRenewalParams} from '~/types/models/questionnaire';
import {isBase64} from '~/utils/helpers';
const queryString = require('query-string');

interface Props {}

const MDQRenewalQuestionnaire1Screen = ({}: Props) => {
  const dispatch: AppDispatch = useDispatch();
  const history = useHistory();
  const mdq = useSelector((state: RootState) => state.questionnaires);
  const {methodKey, medicalUUID, answerOrder, collectedData} = mdq;
  const {loading: checkStatusLoading} = useRequestState(getMdqStatus);
  //   const {wpAuthUser} = medicalQuestionnaire;

  //   const questionnaires = medicalQuestionnaire?.questionnaires;
  const questionnaire = WEIGHT_LOSS_RENEWAL_QUESTIONNAIRES.find(i => i.key === WEIGHT_LOSS_RENEWAL_KEYS.START);

  const onClickSubmit = () => {
    const answerData = {
      key: WEIGHT_LOSS_RENEWAL_KEYS.START,
      index: questionnaire?.index || '',
      data: {},
      order: answerOrder,
    };

    dispatch(setQuestionnaireAnswer(answerData));
    dispatch(
      submitOrLogMdq({
        data: {
          uid: medicalUUID,
          methodKey: methodKey.toLowerCase(),
          status: 'draft',
          data: {
            ...collectedData,
            [WEIGHT_LOSS_RENEWAL_KEYS.START]: answerData,
          },
        },
      }),
    );
    // dispatch(setNextQuestionnaire({value: WEIGHT_LOSS_RENEWAL_KEYS.HOW_IT_WORK}));
    history.push(PAGE_URLS.MDQ_RENEWAL_ADDITIONAL_INFORMATION + window.location.search);
  };

  useEffect(() => {
    const fetchData = async () => {
      const location = window.location;
      const query: MDQRenewalParams = queryString.parse(location.search);
      if (query.payload && isBase64(query.payload)) {
        // const decodedData: {email: string; orderNumber: string} = JSON.parse(atob(query.payload));
      }
      const mdqRenewalUUID = query.uid;
      if (mdqRenewalUUID) {
        dispatch(setMedicalUUID({uid: mdqRenewalUUID}));
        dispatch(setMethodKey({key: METHOD_KEYS.MDQ_RENEWAL}));
        const statusCheckRes = await dispatch(getMdqStatus({id: mdqRenewalUUID || ''}));

        if (requestOK(statusCheckRes, getMdqStatus)) {
          const statusResult = unwrapResult(statusCheckRes);
          if (statusResult?.status === 'submitted' || statusResult?.status === 'expired') {
            history.push(PAGE_URLS.MDQ_RENEWAL_INVALID + `?status=${statusResult?.status}`);
            return;
          }
          if (statusResult?.meta) {
            dispatch(setQuestionnaireMeta({meta: statusResult.meta}));
          }
        } else {
          history.push(PAGE_URLS.MDQ_RENEWAL_INVALID + `?status=expired`);
        }
      } else {
        history.push(PAGE_URLS.MDQ_RENEWAL_INVALID + `?status=expired`);
      }
    };
    fetchData();
  }, [dispatch, history]);

  if (checkStatusLoading) {
    return <UiPageLoading />;
  }

  return (
    <UiQuestionnaireLayout
      actions={questionnaire?.actions}
      handleOnNext={onClickSubmit}
      showBackButton={false}
      pageTitle={questionnaire?.title}
      loading={checkStatusLoading}
      disableNext={checkStatusLoading}
      isFirstScreen
    >
      <Col alignItems="center" textAlign="center" mt={12} mb={1}>
        <Row mb={5}>
          <UiImage url={welcome1} height={100} borderRadius={1.5} mx={2} />
        </Row>
        <Col>
          <UiText fontWeight="bold" mb={1}>
            {questionnaire?.careTeam?.title}
          </UiText>
          <UiText textAlign="center" fontSize="xs" maxW={48}>
            {questionnaire?.careTeam?.description}
          </UiText>
        </Col>
        <UiDivider color="black" my={12} px={1} />
        <Col mb={8} mt={3}>
          <UiText fontSize="2xl" fontWeight="bold" mb={4}>
            {questionnaire?.questions?.default}
          </UiText>
          <UiText textAlign="center" fontSize="xs" maxW={72}>
            {questionnaire?.questions?.description}
          </UiText>
          <UiText textAlign="center" fontSize="xs" maxW={72} mt={1}>
            {questionnaire?.questions?.sub}
          </UiText>
        </Col>
        <Row alignItems="center" justifyContent="center">
          <UiImage boxSize="0.9375rem" url={clock} />
          <UiText fontWeight="bold" fontSize="xs" px={3}>
            {questionnaire?.questions?.estimateTime}
          </UiText>
        </Row>
      </Col>
    </UiQuestionnaireLayout>
  );
};

export default MDQRenewalQuestionnaire1Screen;
